import merge from 'lodash/merge';

export default function modal(ext) {
  return merge({}, modalDefault, ext);
}

let modalDefault = {
  content: {
    top: '20%',
    left: '0',
    right: '0',
    marginLeft: 'auto',
    marginRight: 'auto',
    bottom: 'auto',
    borderRadius: '0',
    padding: '24px',
    border: '0',
    boxShadow: '0px 6px 10px rgba(0, 0, 0, 0.3)',
  },
  overlay: {
    backgroundColor: 'rgba(0,0,0,0.5)',
  },
};
